// extracted by mini-css-extract-plugin
export default {"warning":"warning__H7i0Q"};